<div class="ngx-dialog goreact-modal">
  <div class="goreact-modal-header">
    <h4 [id]="data.dialogTitleId" class="modal-title">
      {{ data.title }}
    </h4>
    <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
      <i class="ficon-app-x"></i>
    </button>
  </div>
  <div class="goreact-modal-body">
    <p [innerHTML]="data.message"></p>
    @for (email of data.emails; track email) {
      <div>{{email}}</div>
    }
    @if (data.additionalMessage) {
      <p class="additional-message" [innerHTML]="data.additionalMessage"></p>
    }
    @for (userName of data.userNames; track userName) {
      <div>{{userName}}</div>
    }
    @if (data.closingMessage) {
      <p class="closing-message" [innerHTML]="data.closingMessage"></p>
    }
  </div>
  <div class="goreact-modal-footer">
    <button
      class="confirm-button primary-btn"
      (click)="close()"
      translate="common_close">
    </button>
  </div>
</div>
